import React from "react"
import CardsCarrousel from "../CardsCarrousel"
import { useTranslation } from "gatsby-plugin-react-i18next"
import StatementModule from "@modules/StatementModule"

const CasesCarrouselSection = ({dataEvent}) => {
  const allCaseStudies = [
    "/improving-production/",
    "/driving-efficiency/",
    "/securing-supply/",
    "/overcoming-global-challenges/",
    "/increasing-revenue/",
    "/financial-flexibility/",
  ]

  const { t } = useTranslation()

  const params = {
    theme: "blue-bg",
    text: [
      {
        text: t("Home_Subheader7"),
        class:
          "desk:!mb-5 !text-[20px] desk:!text-[40px] !font-medium !text-left md:!text-center",
      },
      {
        text: t("Home_Paragraph12"),
        class: "desk:text-[24px] w-full text-left md:text-center",
      },
    ],
    classes: { background: "pb-6 md:pb-[20px] desk:pb-[60px]" },
  }
  return (
    <>
      <StatementModule {...params} />
      <CardsCarrousel allCaseStudies={allCaseStudies} topDivClass={"pb-5"} dataEvent={dataEvent} />
    </>
  )
}

export default CasesCarrouselSection
